<template>
    <body>
    <div style="width:100%;background-color: rgba(0,0,0,0)">

        <!--登录操作框-->
        <div id="actionFrameId"  class="actionFrame">
            <div class="logo">
                <img src="~@/assets/newHome/logo.png" style="width:60%;object-fit: contain" />
            </div>
            <!--底部文字-->
            <div class="text-ctn" style="margin-top: 1rem;width: 80%;margin-left: 10%;margin-top: 3rem;font-size: 1.2rem;">
                尚未创建账号？现在就去<span @click="$router.push('/LearnRegister_mobile')" style="color: #006699;cursor:pointer;">注册</span>
            </div>
            <div class="titleCtn">
                <div @click="loginType=1" :class="loginType==1 ? 'title-1' : 'title-2'" style="margin-right: 40px">
                    短信登录
                </div>
                <div @click="loginType=2" :class="loginType==2 ? 'title-1' : 'title-2'" style="margin-right: 0px">
                    账户密码登录
                </div>
            </div>
            <div v-if="loginType==1" class="loginCtn">
                <!--手机号-->
                <div class="input-ctn" style="margin-top: 50px">
                <v-text-field
                v-model="phone1"
                label="手机号"
                placeholder=" "
                outlined
                @blur="checkPhone"
                >
                <template v-slot:prepend-inner>
                <div style="width:35px;padding-top: 3px;padding-bottom:2px;border-right: solid 1px rgba(0, 0, 0, 0.25);color:rgba(0, 0, 0, 0.35) ">
                +86
                </div>
                </template>
                </v-text-field>
                </div>
                <!--短信验证码-->
                <div class="input-ctn" style="margin-top: 15px">
                <v-text-field
                v-model="messageCode"
                label="短信验证码"
                placeholder=" "
                outlined
                @blur="ifCanRegister"
                >
                <template v-slot:append>
                <v-fade-transition leave-absolute>
                <div @click="clickSendCode" :class="canSendAgain ? 'getAccessCode':'getAccessCode-disabled'" >
                {{countDown}}
                </div>
                </v-fade-transition>
                </template>
                </v-text-field>
                </div>
                <!--服务条款和隐私政策-->
                <div class="input-ctn" style="height: 20px; margin-top: 2rem;word-break: break-all;">
                    <v-checkbox v-model="read_checkbox" @change="ifCanRegister">
                        <template v-slot:label>
                            <div style="width: 99%;line-height: 1.1rem;word-break: break-all;font-size: 0.8rem;">
                                我已阅读并同意
                                <a
                                        target="_blank"
                                        href="/ServiceAgreement_mobile"
                                        @click.stop
                                        style="text-decoration: none; color: #006699"
                                >
                                    《服务协议》
                                </a>
                                和
                                <a
                                        target="_blank"
                                        href="/PrivacyPolicy_mobile"
                                        @click.stop
                                        style="text-decoration: none; color: #006699"
                                >
                                    《隐私政策》
                                </a>
                            </div>
                        </template>
                    </v-checkbox>
                </div>
                <!--点击登录-->
                <div @click="clickLogin" :class="registerAllow ? 'operateButton':'operateButton_disabled'" style="margin-top: 35px;">
                登录
                </div>
            </div>
            <div v-if="loginType==2" class="loginCtn">
                <!--手机号-->
                <div class="input-ctn" style="margin-top: 50px">
                    <v-text-field
                            v-model="phone1"
                            label="手机号"
                            placeholder=" "
                            outlined
                            @blur="checkPhone"
                    >
                        <template v-slot:prepend-inner>
                            <div style="width:35px;padding-top: 3px;padding-bottom:2px;border-right: solid 1px rgba(0, 0, 0, 0.25);color:rgba(0, 0, 0, 0.35) ">
                                +86
                            </div>
                        </template>
                    </v-text-field>
                </div>
                <!--密码-->
                <div class="input-ctn" style="margin-top: 15px">
                    <v-text-field
                            v-model="password"
                            label="密码"
                            placeholder=" "
                            outlined
                            @blur="ifCanRegister2"
                            :type="ifShowPassword ? 'text' : 'password'"
                    >
                        <template v-slot:append>
                            <v-fade-transition leave-absolute>
                                <div v-if="ifShowPassword==false" @click="showPassword" style="width: 30px;height: 20px;margin-top: 5px;margin-left: 10px;cursor:pointer">
                                    <img src="../../assets/Login/显示密码.png" height="13" width="19"/>
                                </div>
                                <div v-if="ifShowPassword==true" @click="hidePassword" style="width: 30px;height: 20px;margin-top: 5px;margin-left: 10px;cursor:pointer">
                                    <img src="../../assets/Login/隐藏密码.png" height="16" width="19"/>
                                </div>
                            </v-fade-transition>
                        </template>
                    </v-text-field>
                </div>
                <!--忘记密码-->
                <!--<div @click="$router.push('/ForgetPassword')" class="forgetPassword">-->
                    <!--忘记密码？-->
                <!--</div>-->
                <!--服务条款和隐私协议-->
                <div class="input-ctn" style="height: 20px; margin-top: 2rem;word-break: break-all;">
                    <v-checkbox v-model="read_checkbox" @change="ifCanRegister2">
                        <template v-slot:label>
                            <div style="width: 99%;line-height: 1.1rem;word-break: break-all;font-size: 0.8rem;">
                                我已阅读并同意
                                <a
                                        target="_blank"
                                        href="/ServiceAgreement_mobile"
                                        @click.stop
                                        style="text-decoration: none; color: #006699"
                                >
                                    《服务协议》
                                </a>
                                和
                                <a
                                        target="_blank"
                                        href="/PrivacyPolicy_mobile"
                                        @click.stop
                                        style="text-decoration: none; color: #006699"
                                >
                                    《隐私政策》
                                </a>
                            </div>
                        </template>
                    </v-checkbox>
                </div>
                <!--点击登录-->
                <div @click="clickLogin2" :class="registerAllow2 ? 'operateButton':'operateButton_disabled'" style="margin-top: 60px;">
                    登录
                </div>
            </div>

            <!--错误提示-->
            <div v-if="showAlert" class="alertCtn">
                <div style="width: 100%;height: auto;margin-top:5vh;text-align: center;">
                    <img src="../../assets/手机弹窗提示.png" style="height: 1.5rem;width: 1.5rem"/>
                </div>
                <div class="alertCtn-txt">
                    {{ alertTip }}
                </div>
                <img
                        class="closeAlert"
                        @click="showAlert = false"
                        src="../../assets/RegisterNew/关闭提示内容.png"
                        height="22"
                        width="22"
                />
            </div>

        </div>

        <div style="width: 100%;height: 1.2rem;line-height: 1.2rem;font-size: 0.8rem;text-align: center;color: #3A3A3A ;margin-top: 20vw;margin-bottom: 1rem;">
            Copyright © 2023-2026 长光卫星技术股份有限公司
        </div>
    </div>
    </body>

</template>

<script>
    // import identify from '../../components/identify.vue';
    export default {
        name: "Login_mobile",
        components:{
            // identify
        },
        data(){
            return{
                ifShowPassword:false,
                registerAllow2:false,//判断是否可以登录（账户密码登录）
                phone2:'',//电话，账户密码登录
                password:'',
                // 图片验证码初始值
                identifyCode: '1234',
                // 图片验证码的随机取值范围
                identifyCodes: '1234567890',
                showAlert:false,//是否现实错误提示
                alertTip:'',//错误提示内容
                countDown:'获取验证码',//发送验证码，与再次发送倒计时
                read_checkbox:false,
                checkPhoneResult:false,//手机号是否正确
                canSendAgain:true,
                registerAllow:false,//是否可以登录
                verifyCodeTrue:true,//验证码是否正确
                messageCode:'',//短信验证码
                verifyCode:'',//图片验证码
                phone1:'',//手机号码（短信登录）
                loginType:1,
                randomPic:7,//1-7随机数，用于选择背景图片
                returnUrl:'',//需要返回的上一个页面
            }
        },
        methods:{
            //识别屏幕缩放比例
            detectZoom(){
                var ratio = 0,
                    screen = window.screen,
                    ua = navigator.userAgent.toLowerCase();

                if (window.devicePixelRatio !== undefined) {
                    ratio = window.devicePixelRatio;
                }
                else if (~ua.indexOf('msie')) {
                    if (screen.deviceXDPI && screen.logicalXDPI) {
                        ratio = screen.deviceXDPI / screen.logicalXDPI;
                    }
                }
                else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
                    ratio = window.outerWidth / window.innerWidth;
                }
                if (ratio){
                    ratio = Math.round(ratio * 100);
                }
                return ratio;
            },
            //设置显示密码
            showPassword(){
                this.ifShowPassword=true;
            },
            //设置隐藏密码
            hidePassword(){
                this.ifShowPassword=false;
            },
            // 图片验证码是否正确
            ifVerifyCodeTrue(){
                //取消图片验证码
                // if(this.identifyCode==this.verifyCode){
                //     //取消电话号码格式错误或验证码错误提示
                //     this.alertTip='';
                //     this.showAlert=false;
                //     this.verifyCodeTrue=true;
                // }
                // else {
                //     //验证码错误提示
                //     this.alertTip='验证码错误，请重新输入';
                //     this.showAlert=true;
                // }
                this.verifyCodeTrue=true;
            },
            // 点击验证码刷新验证码
            changeCode () {
                this.identifyCode = '';
                this.makeCode(this.identifyCodes, 4);
                console.log('identifyCode',this.identifyCode)
            },
            // 生成一个随机整数  randomNum(0, 10) 0 到 10 的随机整数， 包含 0 和 10
            randomNum (min, max) {
                max = max + 1
                return Math.floor(Math.random() * (max - min) + min)
            },
            // 随机生成验证码字符串
            makeCode (data, len) {
                for (let i = 0; i < len; i++) {
                    this.identifyCode += data[this.randomNum(0, data.length - 1)]
                }
            },
            //验证手机格式
            phonePattern:function(phone){
                const pattern = /^[0-9]{11}$/
                if(phone) {
                    return pattern.test(phone) || '请填写正确的手机号码'
                }
                else {
                    return '请填写正确的手机号码'
                }
            },
            //检验手机号码格式
            checkPhone:function(){
                let checkResult=this.phonePattern(this.phone1)
                this.checkPhoneResult=checkResult
                //如果手机号通过正则检验
                if(checkResult==true){
                        //取消电话号码格式错误或验证码错误提示
                        this.alertTip='';
                        this.showAlert=false;
                }
                else {
                    this.alertTip=checkResult;
                    this.showAlert=true;
                }
            },
            //点击获取验证码
            clickSendCode:function () {
                let checkResult=this.phonePattern(this.phone1)
                this.checkPhoneResult=checkResult
                //如果手机号通过正则检验
                if(checkResult==true){
                    if(this.verifyCodeTrue){
                        //取消电话号码格式错误或验证码错误提示
                        this.alertTip='';
                        this.showAlert=false;
                        //如果可以发送验证码
                        if(this.canSendAgain){
                            //立即禁用按钮，防止重复点击
                            this.canSendAgain=false;
                            //调用发送验证码的函数
                            this.sendCode()
                        }
                    }
                    else {
                        //验证码错误提示
                        this.alertTip='验证码错误，请重新输入';
                        this.showAlert=true;
                    }

                }
                else {
                    this.alertTip=checkResult;
                    this.showAlert=true;
                }

            },
            //发送验证码函数
            sendCode:function(){
                console.log("发送验证码函数")
                let param=new FormData();
                param.append('phone', this.phone1)
                param.append('prefix','')
                this.axios.post("/loginapi/loginByVerifyCode",param)
                    .then((res)=>{
                        console.log(res)
                        let resData=res.data;
                        if(resData.success==false){
                            //失败时恢复按钮状态，允许用户重试
                            this.canSendAgain=true;
                            this.alertTip=resData.message;
                            this.showAlert=true;
                        }else{
                          this.sendAgainCountDown();
                        }

                    })
            },
            //发送倒计时
            sendAgainCountDown:function(){
                let t=60;
                this.canSendAgain=false;
                let timer=setInterval(()=> {
                    this.countDown='重新发送 ('+t+'s)'
                    t--;
                    if(t<0){
                        this.canSendAgain=true;
                        this.countDown='获取验证码'
                        clearInterval(timer);
                    }
                },1000)
            },
            //设置token
            setKey(value) {
                localStorage.setItem("token", value);
            },
            //点击登录
            clickLogin:function(){
                if(this.registerAllow){
                    let param=new FormData();
                    param.append('phone', this.phone1)
                    param.append('verifyCode',this.messageCode)
                    this.axios.post("/loginapi/checkCodeForLogin",param)
                        .then((res)=>{
                            this.print(res)
                            let resData=res.data;
                            if(resData.success==false){
                                this.alertTip=resData.message;
                                this.showAlert=true;
                            }
                            else if(resData.success==true){
                                this.$store.state.user.userId = resData.data.account;
                                this.setCookie('userId', resData.data.account);
                                this.$store.state.accountId = resData.data.userId;
                                this.$store.state.user.logined = true;
                                this.setKey(resData.data.key);
                                // if (this.returnUrl !== "") {
                                //     this.$router.push(this.returnUrl);
                                // } else {
                                //     this.$router.push("/");
                                // }
                                this.$router.push("/LearnSignUp_mobile");
                                this.alertTip="";
                                this.showAlert=false;
                            }
                        })
                }

            },
            //点击登录（账号密码）
            clickLogin2:function(){
                if(this.registerAllow2){
                    let param=new FormData();
                    param.append('username', this.phone1)
                    param.append('password',this.password)
                    param.append('remember','on')
                    this.axios.post("/loginapi/login",param)
                        .then((res)=>{
                            this.print(res)
                            let resData=res.data;
                            if(resData.success==false){
                                this.alertTip=resData.message;
                                this.showAlert=true;
                            }
                            else if(resData.success==true){
                                this.$store.state.user.userId = resData.data.account;
                                this.setCookie('userId', resData.data.account);
                                this.$store.state.accountId = resData.data.userId;
                                this.$store.state.user.logined = true;
                                this.setKey(resData.data.key);
                                // if (this.returnUrl !== "") {
                                //     this.$router.push(this.returnUrl);
                                // } else {
                                //     this.$router.push("/");
                                // }
                                this.$router.push("/LearnSignUp_mobile");
                                this.alertTip="";
                                this.showAlert=false;
                            }
                        })
                }
            },
            //判断是否可以登录
            ifCanRegister:function(){
                if(this.checkPhoneResult==true&&this.read_checkbox==true&&this.messageCode.length>1&&this.verifyCodeTrue==true){
                    this.registerAllow=true
                }
                else {
                    this.registerAllow=false
                }

            },
            //判断是否可以登录(账户密码方式)
            ifCanRegister2:function(){
                if(this.checkPhoneResult==true&&this.read_checkbox==true&&this.password.length>1){
                    this.registerAllow2=true
                }
                else {
                    this.registerAllow2=false
                }
            },
            getKey() {
                return localStorage.getItem("token");
            },
        },
        mounted(){
            // 刷新页面就生成随机验证码
            this.identifyCode = ''
            this.makeCode(this.identifyCodes, 4)
            //屏幕适应问题
            // console.log(window.screen.width)
            // console.log('子模块')
            // console.log(this.detectZoom())
            // let screenZoom=this.detectZoom() //屏幕放大倍数
            // let screenWidth=window.screen.width
            // let divFrame = document.getElementById("actionFrameId");
            // if(screenWidth<2500){
            //     divFrame.setAttribute("style","zoom:"+(100-(screenZoom-100)/1.8).toFixed(2).toString()+"%");
            // }
            //如果有token
            if(localStorage.getItem("token")){
                //获取登录状态
                this.axios
                    .get("/loginapi/getLoginInfo", {
                        headers: {
                            Authorization: "Bearer " + this.getKey(),
                        },
                    })
                    .then((res) => {
                        if (res.data.success) {
                            console.log("已登录")
                              this.$router.push("/Login_mobile");

                        } else {
                            console.log("未登录")
                        }
                    });

            }

        },
        created(){


        }
        ,
        watch:{
            messageCode: {
                handler: function() {
                    if(this.messageCode.length>5){
                        this.ifCanRegister();
                    }
                }
            },
            password:{
                handler:function () {
                    if(this.password.length>5){
                        this.ifCanRegister2();
                    }
                }
            },
            showAlert:{
                handler:function (now,old) {
                    console.log(now)
                    let that=this
                    if(now==true){
                        setTimeout(function () {
                            that.showAlert=false
                        },2000)
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .v-label {
        font-size: 14px;
        line-height: 1;
        min-height: 8px;
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    }
    .forgetPassword{
        position:absolute;
        top:372px;
        left:490px;
        width: 70px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #979797;
        line-height: 20px;
        cursor:pointer;
    }
    .loginCtn{
        width: 100%;
        height:430px;
        padding-top: 1px;
    }
    .text2-ctn{
        position:absolute;
        bottom:30px;
        left: 63px;
        width: 499px;
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #979797;
        line-height: 17px;
    }
    .text-ctn{
        margin-left: 10%;
        width: 80%;
        text-align: center;
        height: 1rem;
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #777777;
        line-height: 20px;
        margin-bottom: 2rem;
    }
    .verifyInputCtn{
        width:300px;
        height:60px;
        float:left;
    }
    .input-ctn{
        margin-left: 10%;
        width: 80%;
        height: 60px;
    }
    .title-1{
        font-size:1.5rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3A3A3A;
        line-height: 2.8rem;
        border-bottom: 3px solid #006699;
        float:left;
        padding-bottom: 10px;
        cursor:pointer;
    }
    .title-2{
        font-size: 1.5rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #979797;
        line-height: 2.8rem;
        float:left;
        padding-bottom: 10px;
        cursor:pointer;
    }
    .operateButton {
        width: 80%;
        margin-left: 10%;
        margin-top: 3rem;
        height: 54px;
        line-height: 54px;
        background: #006699;
        border-radius: 8px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        cursor: pointer;
    }
    .operateButton_disabled{
        width: 80%;
        margin-left: 10%;
        margin-top: 3rem;
        height: 54px;
        line-height: 54px;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 8px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        cursor: pointer;
    }
    .getAccessCode {
        width: 150px;
        margin-top: 5px;
        /*height: 40px;*/
        /*line-height: 40px;*/
        text-align: right;
        padding-right: 10px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #006699;
        cursor: pointer;
    }
    .getAccessCode-disabled{
        width: 150px;
        margin-top: 5px;
        /*height: 40px;*/
        /*line-height: 40px;*/
        text-align: right;
        padding-right: 10px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #979797;
        cursor: pointer;
    }
    .titleCtn{
        position: relative;
        display: flex;
        justify-content: center;
        width: 100%;
        height: 3.5rem;
    }
    .logo{
        width: 100%;
        text-align: center;
        margin-bottom:1.5rem;
    }
    .closeAlert{
        position:absolute;
        top:16px;
        right:16px;
        cursor:pointer;
    }
    .alertCtn{
        position: absolute;
        top: 30vh;
        left: 15vw;
        width: 70vw;
        height: 50vw;
        line-height: 54px;
        background: rgba(0,0,0,0.7500);
        border-radius: 8px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
    }
    .actionFrame {
        position:relative;
        margin-top: 4.5rem;
        width: 100%;
        min-height: 500px;
        background: #ffffff;
        border-radius: 16px;
        /*border:solid 1px #ff4040;*/
    }
</style>
